import { envConfig } from '../env'
import { getCurrentUserAsync } from '../models/User'
import { Purchases } from '@revenuecat/purchases-js'
import type { UserType } from '../flowTypes'

export async function getManagementUrlAsync (): Promise<string | null> {
  try {
    const currentUser: UserType = await getCurrentUserAsync()
    if (!currentUser.id) {
      return null
    }

    const apiKey = envConfig().REVENUECAT_API_KEY
    if (!apiKey) {
      console.warn('RevenueCat API key not found in environment variables')
      return null
    }

    const userId = currentUser.id
    const purchases = Purchases.configure(apiKey, userId)
    const customerInfo = await purchases.getCustomerInfo()
    return customerInfo.managementURL
  } catch (error: any) {
    // Handle cross-origin, network, or API errors gracefully
    console.warn('Failed to get RevenueCat management URL:', error.message)
    return null
  }
}
